import { useTranslation } from "react-i18next";
import { Box, Link, Typography } from "@mui/material";
import { useRouter } from "next/router";
import NextLink from "next/link";

import { SignUpForm } from "../../components/sign-up/sign-up-form";
import { EAPP_ROUTE } from "../../enums/route.enum";
import SignUpLayout from "../../components/layout/login/sign-up/SignUpLayout";
import LeftSideMessage from "../../components/login/left-message/LeftSideMessage";

const SignUp = () => {
  const router = useRouter();

  const { t } = useTranslation();
  const invited = router?.query?.invited;

  return (
    <SignUpLayout>
      <LeftSideMessage
        title={"sign_up_page__create_your_first_account"}
        message={
          invited
            ? "sign_up_page__invited_description"
            : "sign_up_page__join_parsly_today"
        }
        secondText={"sign_up_page__fill_information"}
      />

      <Box
        sx={{
          p: "2.4rem",

          "@media (min-width: 769px)": {
            maxWidth: "79.2rem",
            p: "16.4rem 12rem 10.8rem 4.8rem",
          },
        }}
      >
        <Box sx={{ mb: "0.8rem" }}>
          <Typography variant="h6">{t("sign_up_page__fill_form")}</Typography>
        </Box>
        <SignUpForm />
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <NextLink href={EAPP_ROUTE.LOGIN} passHref>
            <Link
              color="primary"
              variant="body2"
              data-testid="sign_up_page__already_have_parsly_account"
            >
              {t("sign_up_page__already_have_parsly_account")}
            </Link>
          </NextLink>
        </Box>
      </Box>
    </SignUpLayout>
  );
};

export default SignUp;
